import { useSelector } from 'modules/react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { changeQbooksAccountLineItemsTaxCode } from '../../../../../actions';
import { getQBooksContext } from '../../../../../selectors/qbooks';
import { getTaxCodeList } from '../../../../../selectors/qbooks/taxSelectors';
import { useAccountLineItems } from './useAccountLineItems';
import { useRequest } from './useRequest';

export const useTaxCodes = () => {
    const dispatch = useDispatch();
    const request = useRequest();

    const accountLineItems = useAccountLineItems();
    const qbooksContext = useSelector(getQBooksContext);
    const taxCodes = getTaxCodeList(qbooksContext, request.details.date);

    useEffect(() => {
        if (taxCodes.length) {
            accountLineItems.forEach((lineItem) => {
                const isExistsTaxCode = taxCodes.some((taxCode) => taxCode.id === lineItem.taxCode?.id);

                if (lineItem.taxCode !== undefined && !isExistsTaxCode) {
                    dispatch(changeQbooksAccountLineItemsTaxCode([lineItem.id], null));
                }
            });
        }
    }, [accountLineItems, dispatch, taxCodes]);

    return taxCodes;
};
